import * as styles from './ControlRow.module.css'

import React from 'react'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'

interface Props {
  children: React.ReactNode
  sticky?: boolean
  breakpoint?: number
}

export const ControlRow: React.FC<Props> = (props) => {
  const { children, sticky = false, breakpoint = 200 } = props

  const columns = useMediaQuery({ query: `(min-width: ${breakpoint}px)` })

  return (
    <div
      className={classNames(styles.container, {
        [styles.sticky]: sticky,
        [styles.columns]: columns,
      })}
    >
      {children}
    </div>
  )
}
